export default __webpack_public_path__ + "static/media/WORKMATE.70e290b5.svg";